import { render, staticRenderFns } from "./tag-group-import-modal.vue?vue&type=template&id=0ac96b56&scoped=true&"
import script from "./tag-group-import-modal.vue?vue&type=script&lang=js&"
export * from "./tag-group-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-group-import-modal.vue?vue&type=style&index=0&id=0ac96b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac96b56",
  null
  
)

export default component.exports